import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { AuthService } from './auth-service';
import { UserService } from '../services';

export const userGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  return inject(UserService)
    .get()
    .pipe(
      switchMap((authenticated) => {
        if (!authenticated) {
          const redirectURL =
            state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
          const urlTree = router.parseUrl(`auth/login?${redirectURL}`);
          return of(urlTree);
        }
        return of(true);
      }),
    );
};
